<template>
	<p @click="showMore = !showMore">{{ computedText }}</p>
</template>

<script>

export default {
	props: {
		data: {
			type: String
		},
    max: {
			type: Number,
      default: 30
		}
	},

	data() {
		return {
			showMore: false
		}
	},

  computed: {
    computedText() {
      if (this.data.length > this.max && !this.showMore) {
        return this.data.slice(0, this.max)+'...';
      } else {
        return this.data
      }
    }
  }
}
</script>
